export default __webpack_public_path__ + "media/images/apple-touch-icon-180x180-precomposed-fd272b89.png";